import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './LandingPage.css';

const LandingPage = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="landing-page">
      <div className="landing-container">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-content">
            <img
              src="/storywriterai.png"
              alt="Storywriter AI Logo"
              className="hero-logo"
            />
            <h1>Storywriter AI</h1>
            <p className="hero-subtitle">
              Your intelligent writing companion for organizing and retrieving your creative content
            </p>
            {isAuthenticated ? (
              <Link to="/search" className="cta-button">
                Go to Dashboard
              </Link>
            ) : (
              <Link to="/settings" className="cta-button">
                Get Started
              </Link>
            )}
          </div>
        </section>

        {/* Video Tutorial Section */}
        <section className="video-tutorial-section">
          <h2>Video Tutorial</h2>
          <p className="video-description">
            Watch our tutorial video to learn how to get the most out of Storywriter AI.
          </p>
          <div className="video-container">
            <iframe
              src="https://www.youtube.com/embed/KI3ccK-yBqY"
              title="Storywriter AI Tutorial"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              frameBorder="0"
              loading="lazy"
            />
          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <h2>Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <span className="feature-icon">📤</span>
              <h3>Upload Content</h3>
              <p>
                Easily upload your text documents, notes, and creative writing.
                Our system automatically chunks and indexes your content for efficient retrieval.
              </p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🔍</span>
              <h3>Smart Search</h3>
              <p>
                Use AI-powered semantic search to find relevant content across all your uploaded materials.
                Find exactly what you need with natural language queries.
              </p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">📋</span>
              <h3>Select & Organize</h3>
              <p>
                Select and organize chunks of text for your current project.
                Keep track of your selected content with our intuitive session management.
              </p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">📥</span>
              <h3>Export</h3>
              <p>
                Export your selected content to use in your creative projects.
                Take your organized content wherever you need it.
              </p>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="how-it-works-section">
          <h2>How It Works</h2>
          <div className="steps-container">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Sign In</h3>
              <p>Sign in securely with your Google account to get started.</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Upload</h3>
              <p>Upload your text content - stories, notes, research, or any text documents.</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Search</h3>
              <p>Search through your content using natural language to find relevant passages.</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Organize & Export</h3>
              <p>Select the best chunks and export them for your creative projects.</p>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="landing-footer">
          <div className="footer-links">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="footer-divider">|</span>
            <a href="mailto:andrewcbuensalida@gmail.com">Contact Us</a>
          </div>
          <p className="copyright">
            © {new Date().getFullYear()} Storywriter AI. All rights reserved.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default LandingPage;
